// import React, { useState, useEffect, useRef } from "react";
// import { Link, useParams, useNavigate } from "react-router-dom";
// import Slider from "react-slick";
// import "slick-carousel/slick/slick.css";
// import "slick-carousel/slick/slick-theme.css";
// import httpClient from "../../utils/httpClients";
// import { usePlayer } from "../../../PlayerContext";

// function Album() {
//     const { id } = useParams();
//     const navigate = useNavigate();
//     const [album, setAlbum] = useState(null);
//     const [songs, setSongs] = useState([]);
//     const [loading, setLoading] = useState(true);
//     const [error, setError] = useState(null);
//     const [genres, setGenres] = useState([]);
//     const [openDropdown, setOpenDropdown] = useState(null);
//     const [likedSongs, setLikedSongs] = useState(new Set());
//     const [sharePopup, setSharePopup] = useState({ open: false, song: null });
//     const [isFollowed, setIsFollowed] = useState(false);

//     const [playlists, setPlaylists] = useState([]);
//     const [playlistModal, setPlaylistModal] = useState({ open: false, song: null });
//     const [showCreateForm, setShowCreateForm] = useState(false);
//     const [newPlaylist, setNewPlaylist] = useState({ name: "", description: "", coverImage: null });
//     const [playlistLoading, setPlaylistLoading] = useState(false);

//     const sliderRef = useRef(null);

//     const {
//         isPlaying,
//         currentTrack,
//         seek,
//         duration,
//         triggerQueueUpdate,
//         tracks
//     } = usePlayer();

//     // Fetch genres for slider
//     const fetchGenresSongs = async () => {
//         try {
//             const res = await httpClient.get(`/user/music/get-themes`);
//             if (res.data?.success) {
//                 setGenres(res.data.data.getThemes || []);
//             }
//         } catch (err) {
//             console.error(err);
//         }
//     };

//     useEffect(() => {
//         fetchGenresSongs();
//     }, []);

//     const isSongCurrentlyPlaying = (songId) => {
//         return currentTrack && currentTrack._id === songId;
//     };

//     const getQueuePosition = (songId) => {
//         const index = tracks.findIndex(track => track._id === songId);
//         return index >= 0 ? index + 1 : null;
//     };

//     // Updated handleQueueAction function to support array of track IDs
//     const handleQueueAction = async (action, trackId = null) => {
//         try {
//             const payload = { action };

//             if (trackId) {
//                 if (action === "addAllToQueue" && Array.isArray(trackId)) {
//                     payload.trackId = trackId;
//                 } else {
//                     payload.trackId = trackId;
//                 }
//             }

//             const res = await httpClient.post("user/queue/queue-controller", payload);

//             if (res.data && res.data.success) {
//                 triggerQueueUpdate();
//                 return true;
//             } else {
//                 console.error("Queue action failed:", res.data);
//                 return false;
//             }
//         } catch (error) {
//             console.error("Queue action error:", error);
//             return false;
//         }
//     };

//     // Remove from queue function
//     const removeFromQueue = async (trackId) => {
//         try {
//             const success = await handleQueueAction("remove", trackId);

//             if (success) {
//                 console.log("✅ Song removed from queue");
//             } else {
//                 console.error("❌ Failed to remove song from queue");
//             }
//         } catch (error) {
//             console.error("Error removing from queue:", error);
//         }
//     };

//     const formatDuration = (seconds) => {
//         if (!seconds || isNaN(seconds)) return "0:00";
//         const mins = Math.floor(seconds / 60);
//         const secs = Math.floor(seconds % 60);
//         return `${mins}:${secs.toString().padStart(2, "0")}`;
//     };

//     const fetchAlbumSongs = async () => {
//         try {
//             setLoading(true);
//             setError(null);

//             const res = await httpClient.get(`/user/music/go-to-album/${id}`);

//             if (res.data && res.data.success) {
//                 const data = res.data.data;
//                 setAlbum(data.album);
//                 setSongs(data.tracks || []);
//                 setIsFollowed(data.album?.isFollow || false);

//                 const likedSongIds = new Set();
//                 data.tracks?.forEach((song) => {
//                     if (song.isLiked) {
//                         likedSongIds.add(song._id);
//                     }
//                 });
//                 setLikedSongs(likedSongIds);

//                 console.log("📊 Album data loaded:", data);
//             } else {
//                 setError("Failed to fetch album data");
//             }
//         } catch (err) {
//             console.error(err);
//             setError("Error fetching album data");
//         } finally {
//             setLoading(false);
//         }
//     };

//     const handleLikeSong = async (contentId, isCurrentlyLiked) => {
//         try {
//             const action = isCurrentlyLiked ? "dislike" : "like";
//             const res = await httpClient.post(
//                 `/user/play-history/like-content/${contentId}/${action}`
//             );

//             if (res.data && res.data.success) {
//                 const newLikedSongs = new Set(likedSongs);
//                 if (isCurrentlyLiked) {
//                     newLikedSongs.delete(contentId);
//                 } else {
//                     newLikedSongs.add(contentId);
//                 }
//                 setLikedSongs(newLikedSongs);

//                 const updatedSongs = songs.map((song) => {
//                     if (song._id === contentId) {
//                         return { ...song, isLiked: !isCurrentlyLiked };
//                     }
//                     return song;
//                 });
//                 setSongs(updatedSongs);
//             }
//         } catch (err) {
//             console.error("Error liking/disliking song:", err);
//         }
//     };

//     const handleFollowAlbum = async () => {
//         try {
//             const action = isFollowed ? "dislike" : "like";
//             const res = await httpClient.post(
//                 `/user/content-follow/like-unlike/${id}/${action}`
//             );

//             if (res.data && res.data.success) {
//                 setIsFollowed(!isFollowed);

//                 // Update album data
//                 setAlbum(prevAlbum => ({
//                     ...prevAlbum,
//                     isFollowed: !isFollowed
//                 }));
//             }
//         } catch (err) {
//             console.error("Error following/unfollowing album:", err);
//         }
//     };

//     const playSong = async (song) => {
//         console.log("🎵 Playing song from album:", song.title, "ID:", song._id);
//         await handleQueueAction("addAndPlay", song._id);
//     };

//     // Updated playAllSongs function
//     const playAllSongs = async () => {
//         if (songs.length > 0) {
//             try {
//                 // Convert array of music objects to array of track IDs
//                 const trackId = songs.map(song => song._id);

//                 // Call the queue action to add all tracks
//                 const success = await handleQueueAction("addAllToQueue", trackId);

//                 if (success) {
//                     console.log("✅ All songs added to queue");

//                     // Play the first song immediately
//                     await playSong(songs[0]);
//                 } else {
//                     console.error("❌ Failed to add songs to queue");
//                 }
//             } catch (error) {
//                 console.error("Error playing all songs:", error);
//             }
//         }
//     };

//     const fetchPlaylists = async () => {
//         try {
//             const res = await httpClient.get("/user/playlist/get-playlists");
//             if (res.data && res.data.success) {
//                 setPlaylists(res.data.data.playlist || []);
//             }
//         } catch (err) {
//             console.error("Error fetching playlists:", err);
//         }
//     };

//     // Open playlist modal
//     const openPlaylistModal = (song, e) => {
//         e.preventDefault();
//         e.stopPropagation();
//         setPlaylistModal({ open: true, song });
//         fetchPlaylists();
//         setOpenDropdown(null);
//     };

//     // Close playlist modal
//     const closePlaylistModal = () => {
//         setPlaylistModal({ open: false, song: null });
//         setShowCreateForm(false);
//         setNewPlaylist({ name: "", description: "", coverImage: null });
//     };

//     // Create new playlist
//     const createNewPlaylist = async () => {
//         if (!newPlaylist.name.trim()) {
//             alert("Please enter playlist name");
//             return;
//         }

//         try {
//             setPlaylistLoading(true);
//             const formData = new FormData();
//             formData.append("name", newPlaylist.name);
//             formData.append("description", newPlaylist.description);
//             if (newPlaylist.coverImage) {
//                 formData.append("coverImage", newPlaylist.coverImage);
//             }

//             const res = await httpClient.post(
//                 "/user/playlist/create-playlist",
//                 formData,
//                 {
//                     headers: {
//                         "Content-Type": "multipart/form-data",
//                     },
//                 }
//             );

//             if (res.data && res.data.success) {
//                 // Refresh playlists
//                 await fetchPlaylists();
//                 setShowCreateForm(false);
//                 setNewPlaylist({ name: "", description: "", coverImage: null });

//                 // If there's a song selected, add it to the new playlist
//                 if (playlistModal.song) {
//                     await addToPlaylist(res.data.data.playlist._id, playlistModal.song._id);
//                 }
//             }
//         } catch (err) {
//             console.error("Error creating playlist:", err);
//             alert("Failed to create playlist");
//         } finally {
//             setPlaylistLoading(false);
//         }
//     };

//     // Add song to playlist
//     const addToPlaylist = async (playlistId, songId) => {
//         try {
//             const params = new URLSearchParams({
//                 playlistId: playlistId,
//                 itemId: songId,
//                 itemType: "Music",
//             });

//             const res = await httpClient.post(`/user/playlist/add-item?${params}`);

//             if (res.data && res.data.success) {
//                 closePlaylistModal();
//             } else {
//                 console.error("Failed to add song to playlist");
//             }
//         } catch (err) {
//             console.error("Error adding song to playlist:", err);
//         }
//     };

//     // Handle file input for cover image
//     const handleFileChange = (e) => {
//         const file = e.target.files[0];
//         if (file) {
//             setNewPlaylist((prev) => ({
//                 ...prev,
//                 coverImage: file,
//             }));
//         }
//     };

//     // Add to queue function
//     const addToQueue = async (trackId) => {
//         try {
//             const success = await handleQueueAction("add", trackId);
//             if (success) {
//                 console.log("✅ Song added to queue");
//             } else {
//                 console.error("❌ Failed to add song to queue");
//             }
//         } catch (error) {
//             console.error("Error adding song to queue:", error);
//         }
//     };

//     const addAlbumToQueue = async () => {
//         if (songs.length > 0) {
//             console.log("➕ Adding all album songs to queue");
//             for (const song of songs) {
//                 await handleQueueAction("add", song._id);
//             }
//         }
//     };

//     const goToalbum = (albumId) => {
//         if (albumId) {
//             console.log("🎤 Going to album:", albumId);
//             navigate(`/art/${albumId}`);
//         }
//     };

//     const handleTitleClick = (song) => {
//         const albumId = song.albumIds?.[0];
//         if (albumId) {
//             goToalbum(albumId);
//         }
//     };

//     const toggleDropdown = (contentId, e) => {
//         if (e) {
//             e.preventDefault();
//             e.stopPropagation();
//         }
//         setOpenDropdown(openDropdown === contentId ? null : contentId);
//     };

//     const openSharePopup = (song, e) => {
//         if (e && e.preventDefault) e.preventDefault();
//         if (e && e.stopPropagation) e.stopPropagation();
//         setSharePopup({ open: true, song });
//     };

//     const openAlbumSharePopup = () => {
//         setSharePopup({
//             open: true,
//             song: {
//                 _id: id,
//                 title: album.title,
//                 isAlbum: true
//             }
//         });
//     };

//     const closeSharePopup = () => {
//         setSharePopup({ open: false, song: null });
//     };

//     const handleCopy = async () => {
//         let text;
//         if (sharePopup.song.isAlbum) {
//             text = `${window.location.origin}/album/${id}`;
//         } else {
//             text = generateShareableUrl(sharePopup.song._id);
//         }

//         try {
//             await navigator.clipboard.writeText(text);
//             console.log("Link copied to clipboard");
//         } catch (err) {
//             console.error("Failed to copy: ", err);

//             // Fallback for older browsers
//             const textArea = document.createElement("textarea");
//             textArea.value = text;
//             textArea.style.position = "fixed";
//             textArea.style.top = 0;
//             textArea.style.left = 0;
//             textArea.style.width = "2em";
//             textArea.style.height = "2em";
//             textArea.style.padding = 0;
//             textArea.style.border = "none";
//             textArea.style.outline = "none";
//             textArea.style.boxShadow = "none";
//             textArea.style.background = "transparent";

//             document.body.appendChild(textArea);
//             textArea.select();

//             try {
//                 document.execCommand("copy");
//                 console.log("Link copied to clipboard");
//             } catch (err) {
//                 alert("Failed to copy text!");
//             }

//             document.body.removeChild(textArea);
//         }
//     };

//     const generateShareableUrl = (songId) => {
//         const encodedSongId = encodeURIComponent(songId);
//         return `${window.location.origin}/volumetv/music/${encodedSongId}`;
//     };

//     const shareOnSocialMedia = (platform, song) => {
//         let shareUrl, shareText;

//         if (song.isAlbum) {
//             shareUrl = `${window.location.origin}/album/${id}`;
//             shareText = encodeURIComponent(`Check out ${album.title} on VolumeTV`);
//         } else {
//             shareUrl = generateShareableUrl(song._id);
//             shareText = encodeURIComponent(song.title);
//         }

//         const shareUrls = {
//             facebook: `https://www.facebook.com/sharer/sharer.php?u=${shareUrl}`,
//             twitter: `https://twitter.com/intent/tweet?url=${shareUrl}&text=${shareText}`,
//             whatsapp: `https://api.whatsapp.com/send?text=${shareText}%20${shareUrl}`,
//             telegram: `https://t.me/share/url?url=${shareUrl}&text=${shareText}`,
//         };

//         if (shareUrls[platform]) {
//             window.open(shareUrls[platform], "_blank", "width=600,height=400");
//         }
//     };

//     const getAlbumDropdownOptions = () => [

//         {
//             label: "Share",
//             icon: "share",
//             onClick: () => {
//                 openAlbumSharePopup();
//                 setOpenDropdown(null);
//             }
//         },
//     ];

//     const getSongDropdownOptions = (song) => {
//         const queuePosition = getQueuePosition(song._id);
//         const albumId = song.albumIds?.[0];

//         return [
//             !queuePosition ? {
//                 label: "Add To Queue",
//                 icon: "playlist_add",
//                 onClick: () => {
//                     addToQueue(song._id);
//                     setOpenDropdown(null);
//                 }
//             } : {
//                 label: "Remove From Queue",
//                 icon: "playlist_remove",
//                 onClick: () => {
//                     removeFromQueue(song._id);
//                     setOpenDropdown(null);
//                 }
//             },
//             {
//                 label: "Add To Playlist",
//                 icon: "library_music",
//                 onClick: (e) => openPlaylistModal(song, e)
//             },
//             {
//                 label: "Go To album",
//                 icon: "person",
//                 onClick: () => {
//                     if (albumId) {
//                         goToalbum(albumId);
//                         setOpenDropdown(null);
//                     }
//                 },
//                 disabled: !albumId
//             },
//             {
//                 label: "Share",
//                 icon: "share",
//                 onClick: () => {
//                     openSharePopup(song);
//                     setOpenDropdown(null);
//                 }
//             }
//         ];
//     };

//     // Common Dropdown Component
//     const DropdownMenu = ({ options, isOpen, position = "dropdown-menu-end" }) => {
//         if (!isOpen) return null;

//         return (
//             <div
//                 className={`dropdown-menu ${position} show`}
//                 style={{
//                     position: "absolute",
//                     top: "100%",
//                     right: position === "dropdown-menu-end" ? "0" : "auto",
//                     left: position === "dropdown-menu-start" ? "0" : "auto",
//                     margin: "5px 0 0 0",
//                     zIndex: 1000,
//                     backgroundColor: "#2a2a2a",
//                     border: "1px solid #444",
//                     borderRadius: "8px",
//                     padding: "8px 0",
//                     minWidth: "180px",
//                     boxShadow: "0 4px 12px rgba(0, 0, 0, 0.5)"
//                 }}
//             >
//                 {options.map((option, index) => (
//                     <a
//                         key={index}
//                         className={`dropdown-item ${option.disabled ? "disabled" : ""}`}
//                         href="#!"
//                         onClick={(e) => {
//                             e.preventDefault();
//                             e.stopPropagation();
//                             if (!option.disabled && option.onClick) {
//                                 option.onClick(e);
//                             }
//                         }}
//                         style={{
//                             cursor: option.disabled ? "not-allowed" : "pointer",
//                             opacity: option.disabled ? 0.5 : 1,
//                             color: "white",
//                             padding: "10px 16px",
//                             display: "flex",
//                             alignItems: "center",
//                             gap: "10px",
//                             fontSize: "14px",
//                             textDecoration: "none",
//                             transition: "background-color 0.2s"
//                         }}
//                         onMouseEnter={(e) => {
//                             if (!option.disabled) {
//                                 e.target.style.backgroundColor = "rgba(255, 255, 255, 0.1)";
//                             }
//                         }}
//                         onMouseLeave={(e) => {
//                             e.target.style.backgroundColor = "transparent";
//                         }}
//                     >
//                         <span className="material-icons" style={{ fontSize: "18px", width: "20px" }}>
//                             {option.icon}
//                         </span>
//                         {option.label}
//                     </a>
//                 ))}
//             </div>
//         );
//     };

//     useEffect(() => {
//         const handleClickOutside = (event) => {
//             if (!event.target.closest(".dropdown")) {
//                 setOpenDropdown(null);
//             }
//         };

//         document.addEventListener("mousedown", handleClickOutside);
//         return () => document.removeEventListener("mousedown", handleClickOutside);
//     }, []);

//     useEffect(() => {
//         if (id) {
//             fetchAlbumSongs();
//         }
//     }, [id]);

//     if (loading) return (
//         <div className="content-inner pb-0 container-fluid" id="page_layout">
//         <div className="row mb-5">
//           <div className="col-lg-12">
//             <div className="d-flex justify-content-center align-items-center" style={{ height: '200px' }}>
//               <div className="spinner-border text-primary" role="status">
//                 <span className="visually-hidden">Loading...</span>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     );

//     if (error) return (
//         <div className="content-inner pb-0 container-fluid">
//             <div className="alert alert-danger">{error}</div>
//         </div>
//     );

//     if (!album) return (
//         <div className="content-inner pb-0 container-fluid">
//             <div className="alert alert-warning">Album not found</div>
//         </div>
//     );

//     // Calculate total duration and format date
//     const totalDuration = songs.reduce((total, song) => total + (song.duration || 0), 0);
//     const totalMinutes = Math.floor(totalDuration / 60);
//     const totalTracks = songs.length;
//     const releaseYear = new Date(album.releaseDate).getFullYear();

//     const sliderSettings = {
//         dots: false,
//         infinite: true,
//         speed: 500,
//         slidesToShow: 6,
//         slidesToScroll: 3,
//         arrows: false,
//         responsive: [
//             {
//                 breakpoint: 1024,
//                 settings: {
//                     slidesToShow: 4,
//                     slidesToScroll: 3,
//                 },
//             },
//             {
//                 breakpoint: 768,
//                 settings: {
//                     slidesToShow: 3,
//                     slidesToScroll: 2,
//                 },
//             },
//             {
//                 breakpoint: 480,
//                 settings: {
//                     slidesToShow: 2,
//                     slidesToScroll: 1,
//                 },
//             },
//         ],
//     };

//     const CustomNextArrow = () => (
//         <div
//             className="swiper-button-next"
//             id="next1"
//             tabIndex={0}
//             role="button"
//             aria-label="Next slide"
//             onClick={() => sliderRef.current && sliderRef.current.slickNext()}
//             style={{ cursor: "pointer" }}
//         >
//             <svg
//                 xmlns="http://www.w3.org/2000/svg"
//                 width="18"
//                 height="19"
//                 viewBox="0 0 18 19"
//                 fill="none"
//             >
//                 <path
//                     d="M15.5855 9.89797L10.523 14.9605C10.4174 15.066 10.2743 15.1253 10.125 15.1253C9.97573 15.1253 9.83258 15.066 9.72703 14.9605C9.62148 14.8549 9.56219 14.7118 9.56219 14.5625C9.56219 14.4132 9.62148 14.2701 9.72703 14.1645L13.8298 10.0625H2.8125C2.66332 10.0625 2.52024 10.0032 2.41475 9.89775C2.30926 9.79226 2.25 9.64918 2.25 9.5C2.25 9.35082 2.30926 9.20774 2.41475 9.10225C2.52024 8.99676 2.66332 8.9375 2.8125 8.9375H13.8298L9.72703 4.83547C9.62148 4.72992 9.56219 4.58677 9.56219 4.4375C9.56219 4.28823 9.62148 4.14508 9.72703 4.03953C9.83258 3.93398 9.97573 3.87469 10.125 3.87469C10.2743 3.87469 10.4174 3.93398 10.523 4.03953L15.5855 9.10203C15.6378 9.15427 15.6793 9.21631 15.7076 9.2846C15.7359 9.35288 15.7504 9.42608 15.7504 9.5C15.7504 9.57392 15.7359 9.64712 15.7076 9.7154C15.6793 9.78369 15.6378 9.84573 15.5855 9.89797Z"
//                     fill="currentColor"
//                 />
//             </svg>
//         </div>
//     );

//     const CustomPrevArrow = () => (
//         <div
//             className="swiper-button-prev"
//             id="prev1"
//             tabIndex={0}
//             role="button"
//             aria-label="Previous slide"
//             onClick={() => sliderRef.current && sliderRef.current.slickPrev()}
//             style={{ cursor: "pointer" }}
//         >
//             <svg
//                 xmlns="http://www.w3.org/2000/svg"
//                 width="18"
//                 height="19"
//                 viewBox="0 0 18 19"
//                 fill="none"
//             >
//                 <path
//                     d="M15.75 9.5C15.75 9.64918 15.6908 9.79226 15.5853 9.89775C15.4798 10.0032 15.3367 10.0625 15.1875 10.0625H4.17025L8.27298 14.1645C8.32525 14.2168 8.3667 14.2788 8.39499 14.3471C8.42327 14.4154 8.43783 14.4886 8.43783 14.5625C8.43783 14.6364 8.42327 14.7096 8.39499 14.7779C8.3667 14.8462 8.32525 14.9082 8.27298 14.9605C8.22072 15.0127 8.15868 15.0542 8.09039 15.0825C8.02211 15.1108 7.94893 15.1253 7.87502 15.1253C7.80111 15.1253 7.72792 15.1108 7.65964 15.0825C7.59135 15.0542 7.52931 15.0127 7.47705 14.9605L2.41455 9.89797C2.36225 9.84573 2.32076 9.78369 2.29245 9.7154C2.26414 9.64712 2.24957 9.57392 2.24957 9.5C2.24957 9.42608 2.26414 9.35288 2.29245 9.2846C2.32076 9.21631 2.36225 9.15427 2.41455 9.10203L7.47705 4.03953C7.58259 3.93398 7.72575 3.87469 7.87502 3.87469C8.02428 3.87469 8.16744 3.93398 8.27298 4.03953C8.37853 4.14508 8.43783 4.28823 8.43783 4.4375C8.43783 4.58677 8.37853 4.72992 8.27298 4.83547L4.17025 8.9375H15.1875C15.3367 8.9375 15.4798 8.99676 15.5853 9.10225C15.6908 9.20774 15.75 9.35082 15.75 9.5Z"
//                     fill="#4A525F"
//                 />
//             </svg>
//         </div>
//     );

//     return (
//         <div className="content-inner pb-0 container-fluid" id="page_layout">
//             <div className="row row--grid">
//                 {/* breadcrumb */}
//                 <div className="col-12">
//                     <ul className="breadcrumb">
//                         <li className="breadcrumb__item">
//                             <Link to="/">Home</Link>
//                         </li>
//                         <li className="breadcrumb__item breadcrumb__item--active">
//                             {album.title}
//                         </li>
//                     </ul>
//                 </div>

//                 {/* Album Header */}
//                 <div className="col-12">
//                     <div className="release">
//                         <div className="release__content trending-song">
//                             <div className="release__cover">
//                                 <img
//                                     src={album.coverImageUrl || "img/album1.jpg"}
//                                     alt={album.title}
//                                 />
//                             </div>
//                             <div className="trending-song-detail">
//                                 <div className="main__title main__title--page">
//                                     <h1>{album.title}</h1>
//                                     <p className="text-muted">{album.album}</p>
//                                 </div>
//                                 <div className="release__stat">
//                                     <span>
//                                         <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
//                                             <path d="M21.65,2.24a1,1,0,0,0-.8-.23l-13,2A1,1,0,0,0,7,5V15.35A3.45,3.45,0,0,0,5.5,15,3.5,3.5,0,1,0,9,18.5V10.86L20,9.17v4.18A3.45,3.45,0,0,0,18.5,13,3.5,3.5,0,1,0,22,16.5V3A1,1,0,0,0,21.65,2.24ZM5.5,20A1.5,1.5,0,1,1,7,18.5,1.5,1.5,0,0,1,5.5,20Zm13-2A1.5,1.5,0,1,1,20,16.5,1.5,1.5,0,0,1,18.5,18ZM20,7.14,9,8.83v-3L20,4.17Z" />
//                                         </svg>{" "}
//                                         {totalTracks} track{totalTracks !== 1 ? 's' : ''} • {totalMinutes}min • {releaseYear}
//                                     </span>
//                                 </div>
//                                 <div className="d-flex justify-content-between gap-3 position-relative">
//                                     <a
//                                         className="release__buy open-modal"
//                                         onClick={playAllSongs}
//                                         disabled={songs.length === 0}
//                                         style={{ cursor: songs.length === 0 ? 'not-allowed' : 'pointer' }}
//                                     >
//                                         <i className="fas fa-play" />
//                                         Play All
//                                     </a>
//                                     <a
//                                         className={`release__buy open-modal ${isFollowed ? "liked" : ""}`}
//                                         onClick={handleFollowAlbum}
//                                         style={{ cursor: 'pointer' }}
//                                     >
//                                         <i className={isFollowed ? "fas fa-heart" : "far fa-heart"}></i>
//                                         {isFollowed ? "Following" : "Follow"}
//                                     </a>

//                                     {/* More Button with Dropdown */}
//                                     <div className="dropdown position-relative">
//                                         <a
//                                             className="release__buy open-modal"
//                                             style={{ cursor: "pointer" }}
//                                             onClick={(e) => toggleDropdown('album-more', e)}
//                                         >
//                                             <i className="fa-solid fa-ellipsis"></i>More
//                                         </a>

//                                         <DropdownMenu
//                                             options={getAlbumDropdownOptions()}
//                                             isOpen={openDropdown === 'album-more'}
//                                             position="dropdown-menu-start"
//                                         />
//                                     </div>
//                                 </div>
//                             </div>
//                         </div>
//                     </div>
//                 </div>

//                 {/* Songs List */}
//                 <div className="col-12">
//                     <div className="release">
//                         <div className="release__list trending">
//                             <ul className="main__list main__list--playlist main__list--dashbox">
//                                 <h4 className="card-title text-capitalize episodes">
//                                     Album Tracks ({songs.length})
//                                 </h4>

//                                 {songs.length > 0 ? songs.map((song, index) => {
//                                     const contentId = song._id;
//                                     const isLiked = likedSongs.has(contentId);
//                                     const isCurrentlyPlaying = isSongCurrentlyPlaying(contentId);
//                                     const queuePosition = getQueuePosition(contentId);
//                                     const isDropdownOpen = openDropdown === contentId;
//                                     const albumId = song.albumIds?.[0];

//                                     return (
//                                         <li
//                                             key={contentId}
//                                             className={`single-item list-1 ${
//                                                 isCurrentlyPlaying ? "active-episode" : ""
//                                             }`}
//                                             style={{
//                                                 backgroundColor: isCurrentlyPlaying ? 'rgba(255, 255, 255, 0.1)' : 'transparent',
//                                                 borderLeft: isCurrentlyPlaying ? '3px solid #1DB954' : '3px solid transparent'
//                                             }}
//                                         >
//                                             {/* Song Cover with Play Button */}
//                                             <div
//                                                 className="single-item__cover"
//                                                 onClick={() => playSong(song)}
//                                                 style={{ cursor: "pointer" }}
//                                             >
//                                                 <img
//                                                     src={song.coverImageUrl || album.coverImageUrl || "img/covers/cover.svg"}
//                                                     alt={song.title}
//                                                 />
//                                                 {isCurrentlyPlaying && isPlaying ? (
//                                                     <svg
//                                                         xmlns="http://www.w3.org/2000/svg"
//                                                         viewBox="0 0 24 24"
//                                                         style={{ fill: "#1DB954" }}
//                                                     >
//                                                         <path d="M16,2a3,3,0,0,0-3,3V19a3,3,0,0,0,6,0V5A3,3,0,0,0,16,2Zm1,17a1,1,0,0,1-2,0V5a1,1,0,0,1,2,0ZM8,2A3,3,0,0,0,5,5V19a3,3,0,0,0,6,0V5A3,3,0,0,0,8,2ZM9,19a1,1,0,0,1-2,0V5A1,1,0,0,1,9,5Z" />
//                                                     </svg>
//                                                 ) : (
//                                                     <svg
//                                                         xmlns="http://www.w3.org/2000/svg"
//                                                         viewBox="0 0 24 24"
//                                                         style={{ fill: isCurrentlyPlaying ? "#1DB954" : "#FFFFFF" }}
//                                                     >
//                                                         <path d="M18.54,9,8.88,3.46a3.42,3.42,0,0,0-5.13,3V17.58A3.42,3.42,0,0,0,7.17,21a3.43,3.43,0,0,0,1.71-.46L18.54,15a3.42,3.42,0,0,0,0-5.92Zm-1,4.19L7.88,18.81a1.44,1.44,0,0,1-1.42,0,1.42,1.42,0,0,1-.71-1.23V6.42a1.42,1.42,0,0,1,.71-1.23A1.51,1.51,0,0,1,7.17,5a1.54,1.54,0,0,1,.71.19l9.66,5.58a1.42,1.42,0,0,1,0,2.46Z" />
//                                                     </svg>
//                                                 )}
//                                             </div>

//                                             {/* Song Title and album */}
//                                             <div className="single-item__title">
//                                                 <h4
//                                                     onClick={() => handleTitleClick(song)}
//                                                     style={{
//                                                         cursor: albumId ? "pointer" : "default",
//                                                         textDecoration: albumId ? "underline" : "none"
//                                                     }}
//                                                     title={albumId ? "Go to album" : ""}
//                                                 >
//                                                     {index + 1}. {song.title}
//                                                     {isCurrentlyPlaying && (
//                                                         <span className="badge bg-success ms-2"
//                                                         style={{  fontSize: "0.7em", color: "#fff"  }}>
//                                                             ▶️ Playing
//                                                         </span>
//                                                     )}
//                                                     {queuePosition && !isCurrentlyPlaying && (
//                                                         <span className="badge bg-info ms-2" style={{  fontSize: "0.7em", color: "#fff"  }}>
//                                                             #{queuePosition} in Queue
//                                                         </span>
//                                                     )}
//                                                 </h4>
//                                                 <span
//                                                     onClick={() => goToalbum(albumId)}
//                                                     style={{
//                                                         cursor: albumId ? "pointer" : "default",
//                                                         textDecoration: albumId ? "underline" : "none"
//                                                     }}
//                                                     title={albumId ? "Go to album" : ""}
//                                                 >
//                                                     {song.album || album.album || "Unknown album"}
//                                                 </span>
//                                             </div>

//                                             {/* Dropdown Menu for Songs */}
//                                             <div className="dropdown position-relative">
//                                                 <span
//                                                     className={`d-flex align-items-center h5 mb-0 ${
//                                                         isDropdownOpen ? "show" : ""
//                                                     }`}
//                                                     onClick={(e) => toggleDropdown(contentId, e)}
//                                                     aria-expanded={isDropdownOpen}
//                                                     style={{ cursor: "pointer", color: "#fff" }}
//                                                 >
//                                                     <i className="fas fa-ellipsis-h"></i>
//                                                 </span>

//                                                 <DropdownMenu
//                                                     options={getSongDropdownOptions(song)}
//                                                     isOpen={isDropdownOpen}
//                                                 />
//                                             </div>

//                                             {/* Like Button */}
//                                             <a
//                                                 href="#!"
//                                                 className={`single-item__add ${isLiked ? "liked" : ""}`}
//                                                 onClick={(e) => {
//                                                     e.preventDefault();
//                                                     handleLikeSong(contentId, isLiked);
//                                                 }}
//                                             >
//                                                 <i className={isLiked ? "fas fa-heart" : "far fa-heart"}></i>
//                                             </a>

//                                             {/* Share Button */}
//                                             <a
//                                                 href="#!"
//                                                 className="single-item__export"
//                                                 onClick={(e) => openSharePopup(song, e)}
//                                             >
//                                                 <i className="fas fa-share"></i>
//                                             </a>

//                                             {/* Time Display */}
//                                             <span className="single-item__time">
//                                                 {isCurrentlyPlaying
//                                                     ? `${formatDuration(seek)} / ${formatDuration(duration)}`
//                                                     : formatDuration(song.duration)}
//                                             </span>
//                                         </li>
//                                     );
//                                 }) : (
//                                     <li className="single-item list-1">
//                                         <div className="single-item__title">
//                                             <h4>No songs available for this album</h4>
//                                         </div>
//                                     </li>
//                                 )}
//                             </ul>
//                         </div>
//                     </div>
//                 </div>
//             </div>

//             {/* Genres Slider Section */}
//             <div className="row">
//                 <div className="col-lg-12 mb-5">
//                     <div className="card-header mb-3">
//                         <div className="header-title">
//                             <h4 className="card-title text-capitalize">
//                                 top song genres for you
//                             </h4>
//                         </div>
//                         <div className="common-album position-relative d-lg-block d-none">
//                             <CustomPrevArrow />
//                             <CustomNextArrow />
//                         </div>
//                     </div>

//                     <div className="swiper overflow-hidden" data-swiper="geners-slider">
//                         <Slider ref={sliderRef} {...sliderSettings}>
//                             {genres.map((genre) => (
//                                 <div key={genre._id} className="swiper-slide mb-3">
//                                     <Link
//                                         to={`/party-music/${genre._id}`}
//                                         className="text-capitalize line-count-1 h5 d-block"
//                                     >
//                                         <img
//                                             src={genre.themeImageUrl || `${process.env.PUBLIC_URL}/img/covers/cover.svg`}
//                                             id={genre._id}
//                                             className="mb-3 img-fluid rounded-3"
//                                             alt="song-img"
//                                         />
//                                         {genre.name}
//                                     </Link>
//                                     <small className="fw-normal text-capitalize line-count-1">
//                                         {genre.description}
//                                     </small>
//                                 </div>
//                             ))}
//                         </Slider>
//                     </div>
//                 </div>
//             </div>

//             {/* Share Popup */}
//             {sharePopup.open && sharePopup.song && (
//                 <div className="modal-overlay" style={{
//                     position: 'fixed',
//                     top: 0,
//                     left: 0,
//                     right: 0,
//                     bottom: 0,
//                     backgroundColor: 'rgba(0, 0, 0, 0.8)',
//                     display: 'flex',
//                     alignItems: 'center',
//                     justifyContent: 'center',
//                     zIndex: 9999
//                 }}>
//                     <div className="share-popup" style={{
//                         backgroundColor: '#1a1a1a',
//                         padding: '25px',
//                         borderRadius: '12px',
//                         width: '90%',
//                         maxWidth: '350px',
//                         color: 'white',
//                         border: '1px solid #333',
//                         boxShadow: '0 10px 30px rgba(0, 0, 0, 0.5)'
//                     }}>
//                         {/* Share popup content - same as album component */}
//                         <div style={{
//                             textAlign: 'center',
//                             marginBottom: '25px'
//                         }}>
//                             <h4 style={{
//                                 margin: '0 0 10px 0',
//                                 fontSize: '18px',
//                                 fontWeight: '600'
//                             }}>
//                                 Share
//                             </h4>
//                             <p style={{
//                                 margin: 0,
//                                 color: '#ccc',
//                                 fontSize: '14px'
//                             }}>
//                                 {sharePopup.song.isAlbum ? sharePopup.song.title : sharePopup.song.title}
//                             </p>
//                         </div>

//                         <div style={{
//                             display: 'flex',
//                             justifyContent: 'center',
//                             gap: '20px',
//                             marginBottom: '25px'
//                         }}>
//                             <button
//                                 onClick={() => shareOnSocialMedia("facebook", sharePopup.song)}
//                                 style={{
//                                     background: 'none',
//                                     border: 'none',
//                                     color: '#1877f2',
//                                     cursor: 'pointer',
//                                     display: 'flex',
//                                     flexDirection: 'column',
//                                     alignItems: 'center',
//                                     gap: '8px',
//                                     fontSize: '12px'
//                                 }}
//                             >
//                                 <div style={{
//                                     width: '50px',
//                                     height: '50px',
//                                     backgroundColor: '#1877f2',
//                                     borderRadius: '50%',
//                                     display: 'flex',
//                                     alignItems: 'center',
//                                     justifyContent: 'center',
//                                     fontSize: '20px'
//                                 }}>
//                                     <i className="fab fa-facebook-f" style={{ color: 'white' }}></i>
//                                 </div>
//                                 Facebook
//                             </button>

//                             <button
//                                 onClick={() => shareOnSocialMedia("twitter", sharePopup.song)}
//                                 style={{
//                                     background: 'none',
//                                     border: 'none',
//                                     color: '#1da1f2',
//                                     cursor: 'pointer',
//                                     display: 'flex',
//                                     flexDirection: 'column',
//                                     alignItems: 'center',
//                                     gap: '8px',
//                                     fontSize: '12px'
//                                 }}
//                             >
//                                 <div style={{
//                                     width: '50px',
//                                     height: '50px',
//                                     backgroundColor: '#1da1f2',
//                                     borderRadius: '50%',
//                                     display: 'flex',
//                                     alignItems: 'center',
//                                     justifyContent: 'center',
//                                     fontSize: '20px'
//                                 }}>
//                                     <i className="fab fa-twitter" style={{ color: 'white' }}></i>
//                                 </div>
//                                 Twitter
//                             </button>

//                             <button
//                                 onClick={() => shareOnSocialMedia("whatsapp", sharePopup.song)}
//                                 style={{
//                                     background: 'none',
//                                     border: 'none',
//                                     color: '#25d366',
//                                     cursor: 'pointer',
//                                     display: 'flex',
//                                     flexDirection: 'column',
//                                     alignItems: 'center',
//                                     gap: '8px',
//                                     fontSize: '12px'
//                                 }}
//                             >
//                                 <div style={{
//                                     width: '50px',
//                                     height: '50px',
//                                     backgroundColor: '#25d366',
//                                     borderRadius: '50%',
//                                     display: 'flex',
//                                     alignItems: 'center',
//                                     justifyContent: 'center',
//                                     fontSize: '20px'
//                                 }}>
//                                     <i className="fab fa-whatsapp" style={{ color: 'white' }}></i>
//                                 </div>
//                                 Whatsapp
//                             </button>

//                             <button
//                                 onClick={() => shareOnSocialMedia("telegram", sharePopup.song)}
//                                 style={{
//                                     background: 'none',
//                                     border: 'none',
//                                     color: '#0088cc',
//                                     cursor: 'pointer',
//                                     display: 'flex',
//                                     flexDirection: 'column',
//                                     alignItems: 'center',
//                                     gap: '8px',
//                                     fontSize: '12px'
//                                 }}
//                             >
//                                 <div style={{
//                                     width: '50px',
//                                     height: '50px',
//                                     backgroundColor: '#0088cc',
//                                     borderRadius: '50%',
//                                     display: 'flex',
//                                     alignItems: 'center',
//                                     justifyContent: 'center',
//                                     fontSize: '20px'
//                                 }}>
//                                     <i className="fab fa-telegram" style={{ color: 'white' }}></i>
//                                 </div>
//                                 Telegram
//                             </button>
//                         </div>

//                         <div style={{
//                             display: 'flex',
//                             gap: '10px',
//                             alignItems: 'center'
//                         }}>
//                             <input
//                                 type="text"
//                                 value={sharePopup.song.isAlbum ? `${window.location.origin}/album/${id}` : generateShareableUrl(sharePopup.song._id)}
//                                 readOnly
//                                 style={{
//                                     flex: 1,
//                                     padding: '12px 15px',
//                                     backgroundColor: '#2a2a2a',
//                                     border: '1px solid #444',
//                                     borderRadius: '8px',
//                                     color: 'white',
//                                     fontSize: '14px'
//                                 }}
//                             />
//                             <button
//                                 onClick={handleCopy}
//                                 style={{
//                                     padding: '12px 20px',
//                                     backgroundColor: '#1DB954',
//                                     color: 'white',
//                                     border: 'none',
//                                     borderRadius: '8px',
//                                     cursor: 'pointer',
//                                     fontSize: '14px',
//                                     fontWeight: '600'
//                                 }}
//                             >
//                                 COPY
//                             </button>
//                         </div>

//                         <button
//                             onClick={closeSharePopup}
//                             style={{
//                                 width: '100%',
//                                 marginTop: '20px',
//                                 padding: '12px',
//                                 backgroundColor: 'transparent',
//                                 color: '#ccc',
//                                 border: '1px solid #444',
//                                 borderRadius: '8px',
//                                 cursor: 'pointer',
//                                 fontSize: '14px'
//                             }}
//                         >
//                             CANCEL
//                         </button>
//                     </div>
//                 </div>
//             )}

//             {/* Playlist Modal */}
//             {playlistModal.open && playlistModal.song && (
//                 <div className="modal-overlay" style={{
//                     position: 'fixed',
//                     top: 0,
//                     left: 0,
//                     right: 0,
//                     bottom: 0,
//                     backgroundColor: 'rgba(0, 0, 0, 0.8)',
//                     display: 'flex',
//                     alignItems: 'center',
//                     justifyContent: 'center',
//                     zIndex: 9999
//                 }}>
//                     <div className="playlist-popup" style={{
//                         backgroundColor: '#1a1a1a',
//                         padding: '25px',
//                         borderRadius: '12px',
//                         width: '90%',
//                         maxWidth: '400px',
//                         color: 'white',
//                         border: '1px solid #333',
//                         boxShadow: '0 10px 30px rgba(0, 0, 0, 0.5)'
//                     }}>
//                         {/* Playlist modal content - same as album component */}
//                         <div style={{
//                             textAlign: 'center',
//                             marginBottom: '20px'
//                         }}>
//                             <h4 style={{
//                                 margin: '0 0 10px 0',
//                                 fontSize: '18px',
//                                 fontWeight: '600',
//                                 color:'#ffff'
//                             }}>
//                                 Add to Playlist
//                             </h4>
//                             <p style={{
//                                 margin: 0,
//                                 color: '#ccc',
//                                 fontSize: '14px'
//                             }}>
//                                 {playlistModal.song.title}
//                             </p>
//                         </div>

//                         {!showCreateForm ? (
//                             <>
//                                 <div style={{ maxHeight: '200px', overflowY: 'auto', marginBottom: '20px' }}>
//                                     {playlists.length > 0 ? (
//                                         playlists.map(playlist => (
//                                             <div
//                                                 key={playlist._id}
//                                                 style={{
//                                                     padding: '12px',
//                                                     border: '1px solid #333',
//                                                     borderRadius: '8px',
//                                                     marginBottom: '8px',
//                                                     cursor: 'pointer',
//                                                     display: 'flex',
//                                                     alignItems: 'center',
//                                                     gap: '10px'
//                                                 }}
//                                                 onClick={() => addToPlaylist(playlist._id, playlistModal.song._id)}
//                                             >
//                                                 <img
//                                                     src={playlist.playlistCoverUrl || "img/covers/cover.svg"}
//                                                     alt={playlist.name}
//                                                     style={{
//                                                         width: '40px',
//                                                         height: '40px',
//                                                         borderRadius: '4px',
//                                                         objectFit: 'cover'
//                                                     }}
//                                                 />
//                                                 <div>
//                                                     <div style={{ fontWeight: '500' }}>{playlist.name}</div>
//                                                     {playlist.description && (
//                                                         <div style={{ fontSize: '12px', color: '#ccc' }}>
//                                                             {playlist.description}
//                                                         </div>
//                                                     )}
//                                                 </div>
//                                             </div>
//                                         ))
//                                     ) : (
//                                         <div style={{
//                                             textAlign: 'center',
//                                             padding: '20px',
//                                             color: '#ccc'
//                                         }}>
//                                             No playlists found
//                                         </div>
//                                     )}
//                                 </div>

//                                 <button
//                                     onClick={() => setShowCreateForm(true)}
//                                     style={{
//                                         width: '100%',
//                                         padding: '12px',
//                                         backgroundColor: '#1DB954',
//                                         color: 'white',
//                                         border: 'none',
//                                         borderRadius: '8px',
//                                         cursor: 'pointer',
//                                         fontSize: '14px',
//                                         fontWeight: '600',
//                                         marginBottom: '10px'
//                                     }}
//                                 >
//                                     Create New Playlist
//                                 </button>
//                             </>
//                         ) : (
//                             <div>
//                                 <div style={{ marginBottom: '15px' }}>
//                                     <label style={{ display: 'block', marginBottom: '5px', fontSize: '14px' }}>
//                                         Playlist Name *
//                                     </label>
//                                     <input
//                                         type="text"
//                                         value={newPlaylist.name}
//                                         onChange={(e) => setNewPlaylist(prev => ({ ...prev, name: e.target.value }))}
//                                         placeholder="Enter playlist name"
//                                         style={{
//                                             width: '100%',
//                                             padding: '10px',
//                                             backgroundColor: '#2a2a2a',
//                                             border: '1px solid #444',
//                                             borderRadius: '6px',
//                                             color: 'white',
//                                             fontSize: '14px'
//                                         }}
//                                     />
//                                 </div>

//                                 <div style={{ marginBottom: '15px' }}>
//                                     <label style={{ display: 'block', marginBottom: '5px', fontSize: '14px' }}>
//                                         Description
//                                     </label>
//                                     <textarea
//                                         value={newPlaylist.description}
//                                         onChange={(e) => setNewPlaylist(prev => ({ ...prev, description: e.target.value }))}
//                                         placeholder="Enter playlist description"
//                                         rows="3"
//                                         style={{
//                                             width: '100%',
//                                             padding: '10px',
//                                             backgroundColor: '#2a2a2a',
//                                             border: '1px solid #444',
//                                             borderRadius: '6px',
//                                             color: 'white',
//                                             fontSize: '14px',
//                                             resize: 'vertical'
//                                         }}
//                                     />
//                                 </div>

//                                 <div style={{ marginBottom: '20px' }}>
//                                     <label style={{ display: 'block', marginBottom: '5px', fontSize: '14px' }}>
//                                         Cover Image
//                                     </label>
//                                     <input
//                                         type="file"
//                                         accept="image/*"
//                                         onChange={handleFileChange}
//                                         style={{
//                                             width: '100%',
//                                             padding: '8px',
//                                             backgroundColor: '#2a2a2a',
//                                             border: '1px solid #444',
//                                             borderRadius: '6px',
//                                             color: 'white',
//                                             fontSize: '14px'
//                                         }}
//                                     />
//                                 </div>

//                                 <div style={{ display: 'flex', gap: '10px' }}>
//                                     <button
//                                         onClick={createNewPlaylist}
//                                         disabled={playlistLoading}
//                                         style={{
//                                             flex: 1,
//                                             padding: '12px',
//                                             backgroundColor: '#1DB954',
//                                             color: 'white',
//                                             border: 'none',
//                                             borderRadius: '8px',
//                                             cursor: playlistLoading ? 'not-allowed' : 'pointer',
//                                             fontSize: '14px',
//                                             fontWeight: '600',
//                                             opacity: playlistLoading ? 0.7 : 1
//                                         }}
//                                     >
//                                         {playlistLoading ? 'Creating...' : 'Create Playlist'}
//                                     </button>
//                                     <button
//                                         onClick={() => setShowCreateForm(false)}
//                                         style={{
//                                             flex: 1,
//                                             padding: '12px',
//                                             backgroundColor: 'transparent',
//                                             color: '#ccc',
//                                             border: '1px solid #444',
//                                             borderRadius: '8px',
//                                             cursor: 'pointer',
//                                             fontSize: '14px'
//                                         }}
//                                     >
//                                         Cancel
//                                     </button>
//                                 </div>
//                             </div>
//                         )}

//                         {!showCreateForm && (
//                             <button
//                                 onClick={closePlaylistModal}
//                                 style={{
//                                     width: '100%',
//                                     marginTop: '10px',
//                                     padding: '12px',
//                                     backgroundColor: 'transparent',
//                                     color: '#ccc',
//                                     border: '1px solid #444',
//                                     borderRadius: '8px',
//                                     cursor: 'pointer',
//                                     fontSize: '14px'
//                                 }}
//                             >
//                                 CLOSE
//                             </button>
//                         )}
//                     </div>
//                 </div>
//             )}
//         </div>
//     );
// }

// export default Album;

import React, { useState, useEffect, useRef } from "react";
import { Link, useParams, useNavigate } from "react-router-dom";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import httpClient from "../../utils/httpClients";
import { usePlayer } from "../../../PlayerContext";

function Album() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [album, setAlbum] = useState(null);
  const [songs, setSongs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [genres, setGenres] = useState([]);
  const [openDropdown, setOpenDropdown] = useState(null);
  const [likedSongs, setLikedSongs] = useState(new Set());
  const [sharePopup, setSharePopup] = useState({ open: false, song: null });
  const [isFollowed, setIsFollowed] = useState(false);

  const [playlists, setPlaylists] = useState([]);
  const [playlistModal, setPlaylistModal] = useState({
    open: false,
    song: null,
  });
  const [showCreateForm, setShowCreateForm] = useState(false);
  const [newPlaylist, setNewPlaylist] = useState({
    name: "",
    description: "",
    coverImage: null,
  });
  const [playlistLoading, setPlaylistLoading] = useState(false);
  const [selectedPlaylistId, setSelectedPlaylistId] = useState(null);

  const sliderRef = useRef(null);

  const {
    isPlaying,
    currentTrack,
    seek,
    duration,
    triggerQueueUpdate,
    tracks = [],
    togglePlayPause,
  } = usePlayer();

  // FETCH GENRES
  const fetchGenresSongs = async () => {
    try {
      const res = await httpClient.get(`/user/music/get-themes`);
      if (res.data?.success) {
        setGenres(res.data.data.getThemes || []);
      }
    } catch (err) {
      console.error("Error fetching genres:", err);
    }
  };

  useEffect(() => {
    fetchGenresSongs();
  }, []);

  // QUEUE HELPERS
  const isSongCurrentlyPlaying = (songId) => currentTrack?._id === songId;
  const getQueuePosition = (songId) => {
    const index = tracks.findIndex((t) => t._id === songId);
    return index >= 0 ? index + 1 : null;
  };

  // QUEUE ACTIONS
  const handleQueueAction = async (action, trackId = null, type = null) => {
    try {
      const payload = { action };
      if (type === "genresong") {
        payload.playlistId = trackId;
        payload.type = "genresong";
      } else if (action === "addAllToQueue" && Array.isArray(trackId)) {
        payload.trackId = trackId;
      } else if (trackId) {
        payload.trackId = trackId;
      }
      const res = await httpClient.post(
        "user/queue/queue-controller",
        payload,
        { skipLoader: true, skipErrorToast: true },
      );
      if (res.data?.success) {
        triggerQueueUpdate();
        return true;
      }
    } catch (err) {
      console.error("Queue error:", err);
      return false;
    }
  };

  const addToQueue = (trackId) => handleQueueAction("add", trackId);

  // FORMAT DURATION
  const formatDuration = (seconds) => {
    if (!seconds || isNaN(seconds)) return "0:00";
    const mins = Math.floor(seconds / 60);
    const secs = Math.floor(seconds % 60);
    return `${mins}:${secs.toString().padStart(2, "0")}`;
  };

  // FETCH ALBUM
  const fetchAlbumSongs = async () => {
    try {
      setLoading(true);
      setError(null);
      const res = await httpClient.get(`/user/music/go-to-album/${id}`);
      if (res.data?.success) {
        const data = res.data.data;
        setAlbum(data.album);
        setSongs(data.tracks || []);
        setIsFollowed(data.album?.isFollow || false);

        const liked = new Set();
        data.tracks?.forEach((s) => s.isLiked && liked.add(s._id));
        setLikedSongs(liked);
      } else {
        setError("Failed to load album");
      }
    } catch (err) {
      setError("Network error");
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  // LIKE SONG (optimistic update)
  const handleLikeSong = async (contentId, isLiked, e) => {
    e.preventDefault();
    e.stopPropagation();
    const newLiked = !isLiked;

    const newSet = new Set(likedSongs);
    isLiked ? newSet.delete(contentId) : newSet.add(contentId);
    setLikedSongs(newSet);
    setSongs((prev) =>
      prev.map((s) => (s._id === contentId ? { ...s, isLiked: newLiked } : s)),
    );

    try {
      const action = isLiked ? "dislike" : "like";
      const res = await httpClient.post(
        `/user/play-history/like-content/${contentId}/${action}`,
        {},
        { skipToast: true, skipLoader: true },
      );
      if (!res.data?.success) {
        const revertSet = new Set(likedSongs);
        setLikedSongs(revertSet);
        setSongs((prev) =>
          prev.map((s) => (s._id === contentId ? { ...s, isLiked } : s)),
        );
      }
    } catch (err) {
      console.error(err);
      const revertSet = new Set(likedSongs);
      setLikedSongs(revertSet);
      setSongs((prev) =>
        prev.map((s) => (s._id === contentId ? { ...s, isLiked } : s)),
      );
    }
  };

  // FOLLOW ALBUM
  const handleFollowAlbum = async (e) => {
    e.preventDefault();
    try {
      const action = isFollowed ? "dislike" : "like";
      const res = await httpClient.post(
        `/user/content-follow/like-unlike/${id}/${action}`,
      );
      if (res.data?.success) {
        setIsFollowed(!isFollowed);
        setAlbum((prev) => ({ ...prev, isFollowed: !isFollowed }));
      }
    } catch (err) {
      console.error(err);
    }
  };

  // PLAY SONG
  const playSong = async (song) => {
    if (isSongCurrentlyPlaying(song._id)) {
      togglePlayPause();
    } else {
      await handleQueueAction("addAndPlay", song._id);
    }
  };

  // PLAY ALL
  const playAllSongs = async (e) => {
    e.preventDefault();
    if (songs.length === 0) return;
    const trackIds = songs.map((s) => s._id);
    const success = await handleQueueAction("addAllToQueue", trackIds);
    if (success) await playSong(songs[0]);
  };

  // GO TO ARTIST
  const goToArtist = (artistId) => {
    if (artistId) {
      navigate(`/art/${artistId}`);
    }
  };

  // GENRE CLICK → API + PLAY + NAVIGATE
  const handleGenreClick = async (genreId) => {
    await handleQueueAction("addAllToQueue", genreId, "genresong");
    navigate(`/party-music/${genreId}`);
  };

  // PLAYLISTS
  const fetchPlaylists = async () => {
    try {
      const res = await httpClient.get("/user/playlist/get-playlists");
      if (res.data?.success) setPlaylists(res.data.data.playlist || []);
    } catch (err) {
      console.error(err);
    }
  };

  const openPlaylistModal = (song, e) => {
    e.preventDefault();
    e.stopPropagation();
    setSelectedPlaylistId(null);
    setPlaylistModal({ open: true, song });
    fetchPlaylists();
    setOpenDropdown(null);
  };

  const closePlaylistModal = () => {
    setPlaylistModal({ open: false, song: null });
    setShowCreateForm(false);
    setNewPlaylist({ name: "", description: "", coverImage: null });
    setSelectedPlaylistId(null);
  };

  const addToPlaylist = async (playlistId, songId) => {
    try {
      setSelectedPlaylistId(playlistId);
      const params = new URLSearchParams({
        playlistId,
        itemId: songId,
        itemType: "Music",
      });
      const res = await httpClient.post(`/user/playlist/add-item?${params}`);
      if (res.data?.success) {
        setTimeout(() => closePlaylistModal(), 800);
      }
    } catch (err) {
      alert("Failed to add");
    }
  };

  const createNewPlaylist = async () => {
    if (!newPlaylist.name.trim()) return alert("Name required");
    setPlaylistLoading(true);
    try {
      const formData = new FormData();
      formData.append("name", newPlaylist.name);
      formData.append("description", newPlaylist.description);
      if (newPlaylist.coverImage)
        formData.append("coverImage", newPlaylist.coverImage);

      const res = await httpClient.post(
        "/user/playlist/create-playlist",
        formData,
        {
          headers: { "Content-Type": "multipart/form-data" },
        },
      );

      if (res.data?.success) {
        await fetchPlaylists();
        setShowCreateForm(false);
        setNewPlaylist({ name: "", description: "", coverImage: null });
        if (playlistModal.song) {
          await addToPlaylist(
            res.data.data.playlist._id,
            playlistModal.song._id,
          );
        }
      }
    } catch (err) {
      alert("Failed to create playlist");
    } finally {
      setPlaylistLoading(false);
    }
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) setNewPlaylist((prev) => ({ ...prev, coverImage: file }));
  };

  // SHARE
  const openSharePopup = (song, e) => {
    e.preventDefault();
    e.stopPropagation();
    setSharePopup({ open: true, song });
  };

  const openAlbumSharePopup = () => {
    setSharePopup({
      open: true,
      song: { _id: id, title: album.title, isAlbum: true },
    });
  };

  const closeSharePopup = () => setSharePopup({ open: false, song: null });

  const generateShareableUrl = (songId) =>
    `${window.location.origin}/music/${encodeURIComponent(songId)}`;

  const handleCopy = async () => {
    const url = sharePopup.song.isAlbum
      ? `${window.location.origin}/album/${id}`
      : generateShareableUrl(sharePopup.song._id);
    try {
      await navigator.clipboard.writeText(url);
    } catch {
      const ta = document.createElement("textarea");
      ta.value = url;
      document.body.appendChild(ta);
      ta.select();
      document.execCommand("copy");
      document.body.removeChild(ta);
    }
  };

  const shareOnSocialMedia = (platform) => {
    const song = sharePopup.song;
    const url = song.isAlbum
      ? `${window.location.origin}/album/${id}`
      : generateShareableUrl(song._id);
    const text = encodeURIComponent(
      song.isAlbum ? `Check out ${album.title} on VolumeTV` : song.title,
    );

    const links = {
      facebook: `https://www.facebook.com/sharer/sharer.php?u的空间=${url}`,
      twitter: `https://twitter.com/intent/tweet?url=${url}&text=${text}`,
      whatsapp: `https://api.whatsapp.com/send?text=${text}%20${url}`,
      telegram: `https://t.me/share/url?url=${url}&text=${text}`,
    };
    window.open(links[platform], "_blank");
  };

  // DROPDOWN
  const toggleDropdown = (key, e) => {
    e.preventDefault();
    e.stopPropagation();
    setOpenDropdown(openDropdown === key ? null : key);
  };

  useEffect(() => {
    const close = (e) => {
      if (!e.target.closest(".dropdown") && !e.target.closest(".more-dropdown"))
        setOpenDropdown(null);
    };
    document.addEventListener("mousedown", close);
    return () => document.removeEventListener("mousedown", close);
  }, []);

  useEffect(() => {
    if (id) fetchAlbumSongs();
  }, [id]);

  if (loading)
    return (
      <div
        className="content-inner pb-0 container-fluid d-flex justify-content-center align-items-center"
        style={{ height: "70vh" }}
      >
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );

  if (error)
    return <div className="alert alert-danger text-center my-5">{error}</div>;
  if (!album)
    return (
      <div className="alert alert-warning text-center my-5">
        Album not found
      </div>
    );

  const totalDuration = songs.reduce((a, s) => a + (s.duration || 0), 0);
  const totalMinutes = Math.floor(totalDuration / 60);
  const totalTracks = songs.length;
  const releaseYear = album.releaseDate
    ? new Date(album.releaseDate).getFullYear()
    : "";

  const sliderSettings = {
    dots: false,
    infinite: genres.length > 6,
    speed: 500,
    slidesToShow: 6,
    slidesToScroll: 3,
    arrows: false,
    responsive: [
      { breakpoint: 1400, settings: { slidesToShow: 5 } },
      { breakpoint: 1200, settings: { slidesToShow: 4 } },
      { breakpoint: 992, settings: { slidesToShow: 3 } },
      { breakpoint: 768, settings: { slidesToShow: 2 } },
      { breakpoint: 576, settings: { slidesToShow: 1 } },
    ],
  };

  const CustomNextArrow = () => (
    <div
      className="swiper-button-next"
      onClick={() => sliderRef.current?.slickNext()}
      style={{ cursor: "pointer", zIndex: 10 }}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="18"
        height="19"
        viewBox="0 0 18 19"
        fill="none"
      >
        <path
          d="M15.5855 9.89797L10.523 14.9605C10.4174 15.066 10.2743 15.1253 10.125 15.1253C9.97573 15.1253 9.83258 15.066 9.72703 14.9605C9.62148 14.8549 9.56219 14.7118 9.56219 14.5625C9.56219 14.4132 9.62148 14.2701 9.72703 14.1645L13.8298 10.0625H2.8125C2.66332 10.0625 2.52024 10.0032 2.41475 9.89775C2.30926 9.79226 2.25 9.64918 2.25 9.5C2.25 9.35082 2.30926 9.20774 2.41475 9.10225C2.52024 8.99676 2.66332 8.9375 2.8125 8.9375H13.8298L9.72703 4.83547C9.62148 4.72992 9.56219 4.58677 9.56219 4.4375C9.56219 4.28823 9.62148 4.14508 9.72703 4.03953C9.83258 3.93398 9.97573 3.87469 10.125 3.87469C10.2743 3.87469 10.4174 3.93398 10.523 4.03953L15.5855 9.10203C15.6378 9.15427 15.6793 9.21631 15.7076 9.2846C15.7359 9.35288 15.7504 9.42608 15.7504 9.5C15.7504 9.57392 15.7359 9.64712 15.7076 9.7154C15.6793 9.78369 15.6378 9.84573 15.5855 9.89797Z"
          fill="currentColor"
        />
      </svg>
    </div>
  );

  const CustomPrevArrow = () => (
    <div
      className="swiper-button-prev"
      onClick={() => sliderRef.current?.slickPrev()}
      style={{ cursor: "pointer", zIndex: 10 }}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="18"
        height="19"
        viewBox="0 0 18 19"
        fill="none"
      >
        <path
          d="M15.75 9.5C15.75 9.64918 15.6908 9.79226 15.5853 9.89775C15.4798 10.0032 15.3367 10.0625 15.1875 10.0625H4.17025L8.27298 14.1645C8.32525 14.2168 8.3667 14.2788 8.39499 14.3471C8.42327 14.4154 8.43783 14.4886 8.43783 14.5625C8.43783 14.6364 8.42327 14.7096 8.39499 14.7779C8.3667 14.8462 8.32525 14.9082 8.27298 14.9605C8.22072 15.0127 8.15868 15.0542 8.09039 15.0825C8.02211 15.1108 7.94893 15.1253 7.87502 15.1253C7.80111 15.1253 7.72792 15.1108 7.65964 15.0825C7.59135 15.0542 7.52931 15.0127 7.47705 14.9605L2.41455 9.89797C2.36225 9.84573 2.32076 9.78369 2.29245 9.7154C2.26414 9.64712 2.24957 9.57392 2.24957 9.5C2.24957 9.42608 2.26414 9.35288 2.29245 9.2846C2.32076 9.21631 2.36225 9.15427 2.41455 9.10203L7.47705 4.03953C7.58259 3.93398 7.72575 3.87469 7.87502 3.87469C8.02428 3.87469 8.16744 3.93398 8.27298 4.03953C8.37853 4.14508 8.43783 4.28823 8.43783 4.4375C8.43783 4.58677 8.37853 4.72992 8.27298 4.83547L4.17025 8.9375H15.1875C15.3367 8.9375 15.4798 8.99676 15.5853 9.10225C15.6908 9.20774 15.75 9.35082 15.75 9.5Z"
          fill="#4A525F"
        />
      </svg>
    </div>
  );

  return (
    <div className="content-inner pb-0 container-fluid" id="page_layout">
      <div className="row row--grid">
        {/* Breadcrumb */}
        <div className="col-12 mb-3">
          <ul className="breadcrumb">
            <li className="breadcrumb__item">
              <Link to="/">Home</Link>
            </li>
            <li className="breadcrumb__item breadcrumb__item--active">
              {album.title}
            </li>
          </ul>
        </div>

        {/* Album Header */}
        <div className="col-12 mb-4">
          <div className="release">
            <div className="release__content trending-song d-flex flex-column flex-md-row align-items-center gap-4">
              <div className="release__cover">
                <img
                  src={album.coverImageUrl || "img/covers/cover.svg"}
                  alt={album.title}
                  className="img-fluid rounded"
                  style={{
                    width: "200px",
                    height: "200px",
                    objectFit: "cover",
                  }}
                />
              </div>
              <div className="trending-song-detail flex-grow-1">
                <h1 className="display-5 fw-bold mb-2">{album.title}</h1>
                <p className="text-muted mb-3">
                  {album.artist || "Unknown Artist"}
                </p>
                <div className="release__stat mb-3">
                  <span>
                    <i className="fas fa-music me-1"></i>
                    {totalTracks} track{totalTracks !== 1 ? "s" : ""} •{" "}
                    {totalMinutes} min • {releaseYear}
                  </span>
                </div>

                <div className="d-flex gap-3 align-items-center flex-wrap">
                  <a
                    href="#!"
                    className="btn btn-success rounded-pill px-4 py-2"
                    onClick={playAllSongs}
                  >
                    <i className="fas fa-play me-2"></i>Play All
                  </a>

                  <a
                    href="#!"
                    className={`btn ${isFollowed ? "btn-success" : "btn-outline-light"} rounded-pill px-4 py-2`}
                    onClick={handleFollowAlbum}
                  >
                    <i
                      className={isFollowed ? "fas fa-heart" : "far fa-heart"}
                    ></i>{" "}
                    {isFollowed ? "Following" : "Follow"}
                  </a>

                  <div className="more-dropdown position-relative">
                    <a
                      href="#!"
                      className="btn btn-outline-light rounded-pill px-3"
                      onClick={(e) => toggleDropdown("album", e)}
                    >
                      <i className="fas fa-ellipsis-h"></i>
                    </a>
                    {openDropdown === "album" && (
                      <div
                        className="dropdown-menu show"
                        style={{
                          position: "absolute",
                          top: "100%",
                          right: 0,
                          zIndex: 9999,
                          background: "#2a2a2a",
                          border: "1px solid #444",
                          borderRadius: "12px",
                          minWidth: "180px",
                          boxShadow: "0 8px 25px rgba(0,0,0,0.6)",
                        }}
                      >
                        <a
                          href="#!"
                          className="dropdown-item"
                          onClick={(e) => {
                            e.preventDefault();
                            openAlbumSharePopup();
                            setOpenDropdown(null);
                          }}
                        >
                          <i className="fas fa-share me-2"></i>Share
                        </a>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Songs List */}
        <div className="col-12">
          <div className="release">
            <div className="release__list trending">
              <ul className="main__list main__list--playlist main__list--dashbox p-0">
                <h4 className="card-title text-capitalize episodes mb-3">
                  Tracks
                </h4>
                {songs.map((song, i) => {
                  const isPlayingNow = isSongCurrentlyPlaying(song._id);
                  const isLiked = likedSongs.has(song._id);
                  const inQueue = getQueuePosition(song._id);
                  const artistId = song.artistIds?.[0];

                  return (
                    <li
                      key={song._id}
                      className={`single-item list-1 d-flex align-items-center py-3 px-3 rounded-3 mb-2 ${isPlayingNow ? "active-episode" : ""}`}
                      style={{
                        backgroundColor: isPlayingNow
                          ? "rgba(29, 185, 84, 0.15)"
                          : "transparent",
                      }}
                    >
                      <div
                        className="single-item__cover me-3 position-relative"
                        onClick={() => playSong(song)}
                        style={{
                          cursor: "pointer",
                          width: "50px",
                          height: "50px",
                        }}
                      >
                        <img
                          src={
                            song.coverImageUrl ||
                            album.coverImageUrl ||
                            "img/covers/cover.svg"
                          }
                          alt=""
                          className="img-fluid rounded"
                        />
                        <div className="position-absolute top-50 start-50 translate-middle">
                          {isPlayingNow && isPlaying ? (
                            <i
                              className="fas fa-pause text-success"
                              style={{ fontSize: "20px" }}
                            ></i>
                          ) : (
                            <i
                              className="fas fa-play text-white"
                              style={{ fontSize: "20px" }}
                            ></i>
                          )}
                        </div>
                      </div>

                      <div className="single-item__title flex-grow-1">
                        <h4 className="mb-1">
                          {i + 1}. {song.title}
                          {isPlayingNow && (
                            <span className="badge bg-success ms-2">
                              Playing
                            </span>
                          )}
                        </h4>
                        <span
                          className="text-muted small"
                          style={{ cursor: artistId ? "pointer" : "default" }}
                          onClick={() => artistId && goToArtist(artistId)}
                        >
                          {song.artist || "Unknown Artist"}
                        </span>
                      </div>

                      <div className="d-flex align-items-center gap-3">
                        <a
                          href="#!"
                          className={`single-item__add ${isLiked ? "liked" : ""}`}
                          onClick={(e) => handleLikeSong(song._id, isLiked, e)}
                        >
                          <i
                            className={
                              isLiked ? "fas fa-heart" : "far fa-heart"
                            }
                            style={{ fontSize: "18px" }}
                          ></i>
                        </a>

                        <div className="dropdown">
                          <span
                            className="text-white"
                            onClick={(e) => toggleDropdown(song._id, e)}
                            style={{ cursor: "pointer" }}
                          >
                            <i className="fas fa-ellipsis-h"></i>
                          </span>
                          {openDropdown === song._id && (
                            <div
                              className="dropdown-menu show"
                              style={{
                                position: "absolute",
                                top: "100%",
                                right: 0,
                                background: "#2a2a2a",
                                border: "1px solid #444",
                                borderRadius: "8px",
                                minWidth: "180px",
                                zIndex: 1000,
                                padding: "8px 0",
                              }}
                            >
                              <a
                                href="#!"
                                className="dropdown-item d-flex align-items-center gap-2"
                                onClick={(e) => {
                                  e.preventDefault();
                                  handleQueueAction("add", song._id);
                                  setOpenDropdown(null);
                                }}
                              >
                                <span className="material-icons">
                                  playlist_add
                                </span>{" "}
                                Add to Queue
                              </a>
                              <a
                                href="#!"
                                className="dropdown-item d-flex align-items-center gap-2"
                                onClick={(e) => openPlaylistModal(song, e)}
                              >
                                <span className="material-icons">
                                  library_music
                                </span>{" "}
                                Add to Playlist
                              </a>
                              <a
                                href="#!"
                                className="dropdown-item d-flex align-items-center gap-2"
                                onClick={() => artistId && goToArtist(artistId)}
                              >
                                <span className="material-icons">
                                  library_music
                                </span>{" "}
                                Go To Artist
                              </a>
                              <a
                                href="#!"
                                className="dropdown-item d-flex align-items-center gap-2"
                                onClick={(e) => openSharePopup(song, e)}
                              >
                                <span className="material-icons">share</span>{" "}
                                Share
                              </a>
                            </div>
                          )}
                        </div>

                        <a
                          href="#!"
                          className="single-item__export"
                          onClick={(e) => openSharePopup(song, e)}
                        >
                          <i className="fas fa-share"></i>
                        </a>

                        <span className="text-muted small">
                          {isPlayingNow
                            ? `${formatDuration(seek)} / ${formatDuration(duration)}`
                            : formatDuration(song.duration)}
                        </span>
                      </div>
                    </li>
                  );
                })}
              </ul>
            </div>
          </div>
        </div>
      </div>

      {/* GENRES SLIDER */}
      <div className="row mt-5">
        <div className="col-12">
          <div className="card-header mb-3 d-flex justify-content-between align-items-center">
            <h4 className="card-title mb-0">Top song genres for you</h4>
            <div className="common-album d-lg-flex d-none gap-3">
              <CustomPrevArrow />
              <CustomNextArrow />
            </div>
          </div>
          <Slider ref={sliderRef} {...sliderSettings}>
            {genres.map((genre) => (
              <div key={genre._id} className="px-2">
                <div
                  className="position-relative overflow-hidden rounded-3"
                  style={{ cursor: "pointer" }}
                  onClick={() => handleGenreClick(genre._id)}
                >
                  <img
                    src={genre.themeImageUrl || `${process.env.PUBLIC_URL}/img/covers/cover.svg`}
                    alt={genre.name}
                    className="img-fluid w-100"
                    style={{ height: "180px", objectFit: "cover" }}
                  />
                  <div className="position-absolute inset-0 bg-dark opacity-0 hover-opacity-50 transition-opacity"></div>
                  <div className="position-absolute top-50 start-50 translate-middle opacity-0 hover-opacity-100 transition-opacity">
                    <button
                      className="btn btn-success rounded-circle"
                      style={{ width: "60px", height: "60px" }}
                    >
                      <i className="fas fa-play"></i>
                    </button>
                  </div>
                </div>
                <div className="mt-3">
                  <h6 className="mb-1 text-capitalize text-white">
                    {genre.name}
                  </h6>
                  <small className="text-muted">{genre.description}</small>
                </div>
              </div>
            ))}
          </Slider>
        </div>
      </div>

      {/* SHARE MODAL */}
      {sharePopup.open && sharePopup.song && (
        <div
          className="modal-overlay"
          style={{
            position: "fixed",
            inset: 0,
            background: "rgba(0,0,0,0.9)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 9999,
          }}
        >
          <div
            className="bg-dark p-4 rounded"
            style={{ width: "90%", maxWidth: "400px" }}
          >
            <h5 className="text-center mb-3">Share</h5>
            <p className="text-center text-muted small mb-4">
              {sharePopup.song.isAlbum ? album.title : sharePopup.song.title}
            </p>
            <div className="d-flex justify-content-center gap-3 mb-4">
              {["facebook", "twitter", "whatsapp", "telegram"].map((p) => (
                <button
                  key={p}
                  onClick={() => shareOnSocialMedia(p)}
                  className="btn btn-outline-light rounded-circle"
                  style={{ width: "50px", height: "50px" }}
                >
                  <i
                    className={`fab fa-${p === "twitter" ? "x-twitter" : p}`}
                  ></i>
                </button>
              ))}
            </div>
            <div className="input-group">
              <input
                type="text"
                className="form-control bg-secondary text-white"
                readOnly
                value={
                  sharePopup.song.isAlbum
                    ? `${window.location.origin}/album/${id}`
                    : generateShareableUrl(sharePopup.song._id)
                }
              />
              <button className="btn btn-success" onClick={handleCopy}>
                Copy
              </button>
            </div>
            <button
              className="btn btn-outline-light w-100 mt-3"
              onClick={closeSharePopup}
            >
              Close
            </button>
          </div>
        </div>
      )}

      {/* PLAYLIST MODAL */}
      {playlistModal.open && playlistModal.song && (
        <div
          className="modal-overlay"
          style={{
            position: "fixed",
            inset: 0,
            background: "rgba(0,0,0,0.9)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 9999,
          }}
        >
          <div
            className="bg-dark p-4 rounded"
            style={{ width: "90%", maxWidth: "420px" }}
          >
            <h5 className="text-center mb-3">Add to Playlist</h5>
            <p className="text-center text-muted small mb-4">
              {playlistModal.song.title}
            </p>

            {!showCreateForm ? (
              <>
                <div style={{ maxHeight: "300px", overflowY: "auto" }}>
                  {playlists.map((pl) => (
                    <div
                      key={pl._id}
                      className={`d-flex align-items-center p-3 rounded mb-2 cursor-pointer ${selectedPlaylistId === pl._id ? "bg-success" : "bg-secondary"}`}
                      onClick={() =>
                        addToPlaylist(pl._id, playlistModal.song._id)
                      }
                    >
                      <img
                        src={pl.playlistCoverUrl || "/img/live/songDefault.png"}
                        alt=""
                        className="me-3 rounded"
                        style={{ width: "40px", height: "40px" }}
                      />
                      <div className="flex-grow-1">
                        <div className="text-white">{pl.name}</div>
                        {pl.description && (
                          <small className="text-muted">{pl.description}</small>
                        )}
                      </div>
                      {selectedPlaylistId === pl._id && (
                        <i className="fas fa-check text-white"></i>
                      )}
                    </div>
                  ))}
                </div>
                <button
                  className="btn btn-outline-light w-100 mt-3"
                  onClick={() => setShowCreateForm(true)}
                >
                  Create New Playlist
                </button>
              </>
            ) : (
              <div>
                <input
                  type="text"
                  placeholder="Playlist name"
                  className="form-control mb-3"
                  value={newPlaylist.name}
                  onChange={(e) =>
                    setNewPlaylist((p) => ({ ...p, name: e.target.value }))
                  }
                />
                <textarea
                  placeholder="Description"
                  className="form-control mb-3"
                  rows="2"
                  value={newPlaylist.description}
                  onChange={(e) =>
                    setNewPlaylist((p) => ({
                      ...p,
                      description: e.target.value,
                    }))
                  }
                ></textarea>
                <input
                  type="file"
                  accept="image/*"
                  className="form-control mb-3"
                  onChange={handleFileChange}
                />
                <div className="d-flex gap-2">
                  <button
                    className="btn btn-success flex-fill"
                    onClick={createNewPlaylist}
                    disabled={playlistLoading}
                  >
                    {playlistLoading ? "Creating..." : "Create"}
                  </button>
                  <button
                    className="btn btn-outline-light flex-fill"
                    onClick={() => setShowCreateForm(false)}
                  >
                    Cancel
                  </button>
                </div>
              </div>
            )}
            {!showCreateForm && (
              <button
                className="btn btn-outline-light w-100 mt-3"
                onClick={closePlaylistModal}
              >
                Close
              </button>
            )}
          </div>
        </div>
      )}
    </div>
  );
}

export default Album;
